export default function isNotNull(x) {
    return x !== null;
};
export function isNotNullish(x) {
    return x != null;
}
